import { Text, View } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight, convertPercentageToNumber } from '~/utils'

export const TradeTagContainer = styled(View, theme => {
  return {
    base: {
      width: theme.sizingColossal,
      height: theme.sizingExtrasmall,
      backgroundColor: theme.colorFillNeutralDefault,
      borderRadius: theme.borderRadiusPill,
      borderColor: theme.colorFormsBorderFilled,
      borderStyle: 'dashed',
      borderWidth: 1,
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: theme.paddingInsetTwopulse,
      marginLeft: 'auto',
      marginRight: 'auto'
    },
  }
})

export const TradeDefaultContainer = styled(View, theme => {
  return {
    base: {
      maxWidth: theme.sizingColossal,
      width: '60%',
      overflow: 'hidden',
    },
  }
})

export const TradeTagTitle = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.semiBold,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
  }
})
